import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
 import { makeStyles } from '@material-ui/styles';
 import Pagination from '@material-ui/lab/Pagination';
 import { useHistory } from "react-router-dom";

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Switch,
  Divider,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  colors,
  TableContainer
} from '@material-ui/core';

import { Label,  TableEditBar } from '../../../../components';
import EditIcon from '@material-ui/icons/Edit';
import VisibileIcon from '@material-ui/icons/Visibility';

const useStyles = makeStyles(theme => ({
  root: {},
  filterButton: {
    marginRight: theme.spacing(2)
  },
  content: {
    padding: 0
  },
  inner: {
  //  minWidth: 1150
  },
  actions: {
    padding: theme.spacing(2, 1),
    justifyContent: 'center'
  },
  nodataCont: {
    textAlign: "center",
    padding: "14px",
    fontSize: "18px",
    color: "#bfbfbf",
    fontWeight: 800
},
}));

const Results = props => {
  const { className,rowsPerPage, orders, ...rest } = props;
  let history = useHistory();

  const classes = useStyles();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [page, setPage] = useState(0);


  useEffect(() => {
    if(orders.length < 100)
    {
      setPage(0)
    }
 
  }, [orders]) 
  const handleSelectAll = event => {
    const selectedOrders = event.target.checked
      ? orders.map(order => order.id)
      : [];

    setSelectedOrders(selectedOrders);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedOrders.indexOf(id);
    let newSelectedOrders = [];

    if (selectedIndex === -1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders, id);
    } else if (selectedIndex === 0) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(1));
    } else if (selectedIndex === selectedOrders.length - 1) {
      newSelectedOrders = newSelectedOrders.concat(selectedOrders.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedOrders = newSelectedOrders.concat(
        selectedOrders.slice(0, selectedIndex),
        selectedOrders.slice(selectedIndex + 1)
      );
    }

    setSelectedOrders(newSelectedOrders);
  };
  function Useredit(id,viewtype){
    // localStorage.setItem('productEditId',id);
    history.push(`edituser/${id}/${viewtype}`)
  }
  const handleChangePage = (event, page) => {
    setPage(page);
    props.onPagechange(page)
  };

  const handleChangeRowsPerPage = event => {
    props.onPagelimit(event.target.value);
  };
  
  const paymentStatusColors = {
    canceled: colors.grey[600],
    pending: colors.orange[600],
    active: colors.green[600],
    inactive: colors.red[600]
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
     
      <Card>
        <CardHeader
          
          title="Users"
        />
        <Divider />
        <CardContent className={classes.content}>
            <div className={classes.inner}>
              <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>S no</TableCell>
                    <TableCell>Name</TableCell>
                    <TableCell>Mobile</TableCell>
                    <TableCell>Customer Type</TableCell>
                    <TableCell>City</TableCell>
                    <TableCell>Company Name</TableCell>
                    <TableCell>Last Login</TableCell>
                    <TableCell>Member Since</TableCell>

                    <TableCell>status</TableCell>
                    
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {orders
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((order,index) => (
                    <TableRow
                      key={order.id}
                      selected={selectedOrders.indexOf(order.id) !== -1}
                    >
                 
                      <TableCell>
                        {(page * rowsPerPage)+(index + 1)}
                        
                      </TableCell>

                      <TableCell>{order.name}</TableCell>
                      <TableCell>{order.mobilenumber}</TableCell>
                      <TableCell>{order.customergroup}</TableCell>
                      <TableCell>{order.city}</TableCell>
                      <TableCell>{order.companyname}</TableCell>
                      <TableCell>
                      <Typography variant="body1">
                          {order.last_login ? moment(order.last_login).format(
                            'DD MMM YYYY hh:mm a'
                          ) : "-"}
                        </Typography>
                        </TableCell>
                        <TableCell>
                      <Typography variant="body1">
                          {moment(order.created_at).format(
                            'DD MMM YYYY hh:mm a'
                          )}
                        </Typography>
                        </TableCell>
                      <TableCell>
                         <Label
                          color={paymentStatusColors[order.status == 3 ? 'active' : 'inactive']}
                          variant="contained"
                        >
                          {order.status == 3 ? 'Active' : 'In Active'}
                        </Label>

                      </TableCell>
                   
                     
                      <TableCell align="center">
                      <Button 
                      onClick={() => Useredit(order.id,1)}
                       ><EditIcon />
                           </Button>
                           <Button  
                           onClick={() =>Useredit(order.id,2)}><VisibileIcon />
                           </Button>
                      </TableCell>
                      
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {orders.length > 0 ? "" : <Typography className={classes.nodataCont} component={"h6"} >No Records found</Typography>}
               </TableContainer>   
            </div>
        </CardContent>
        <CardActions className={classes.actions}>
          
          <TablePagination
            component="div"
            count={props.totalcount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25,100]}
          />
      {/* <Pagination count={10} color="secondary" /> */}

        </CardActions>
      </Card>
      <TableEditBar selected={selectedOrders} />
    </div>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  orders: PropTypes.array.isRequired,
  rowsPerPage : PropTypes.number
};


export default Results;
